/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InitialDataResource } from '../models/InitialDataResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DataCacheService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Referentiels de l'entreprise
     * En un appel, tout ce dont l'application a besoin au demarrage : `AGENCES`, `NATURE_RDV`, `CIVILITE`, `ROLE`, `ORIGINE`, `TYPE_ANNULATION`, `TYPE_INTERVENTION`, `TYPE_PRODUIT_GENERIQUE`, `TVA`, la `COMPANY` avec ses personnels actifs, et `BUCKET_SIZE` (espace Drive utilise). Mis en cache 1 h par entreprise.
     * @returns InitialDataResource `InitialDataResource`
     * @throws ApiError
     */
    public dataCacheIndex(): CancelablePromise<InitialDataResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/datacache',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
